import { render } from "./AddNewMenuModifier.vue?vue&type=template&id=d2ab067a&scoped=true"
import script from "./AddNewMenuModifier.vue?vue&type=script&lang=js"
export * from "./AddNewMenuModifier.vue?vue&type=script&lang=js"

import "./AddNewMenuModifier.vue?vue&type=style&index=0&id=d2ab067a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ab067a"]])

export default __exports__